function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2f33"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2f33"] = parcelRequire;
}
parcelRequire.register("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = {};
function $18c11f3350a906ea$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$18c11f3350a906ea$var$mapping[keys[i]] = pairs[keys[i]];
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $7d9cab8efa161a1a$exports = {};

(parcelRequire("27Lyk")).register(JSON.parse('{"4JWgZ":"index.f6abe6cc.js","8v8H6":"logo.1ec8dfcf.png","d1kZ0":"addictinggames.de802442.png","i5q0k":"iogames.3b82d2a7.webp","a1vmr":"kongregate.9e8ef9f1.webp","59XMg":"crazygames.b8c46d2e.png","cx9h3":"pxkw_w.c0c2bd05.png","4gwYA":"pxkw_arrow_up.134d957a.png","iGE9x":"pxkw_a.88868d95.png","dKYJo":"pxkw_arrow_left.be3ab996.png","cbtiy":"pxkw_s.4b66eabd.png","6l7yo":"pxkw_arrow_down.8ff0faf8.png","eTeyd":"pxkw_d.45d670dd.png","bDmaD":"pxkw_arrow_right.e68f7905.png","dC9Hz":"pxkw_1.356004d5.png","5OZCA":"pxkw_2.560494ed.png","cyHCR":"pxkw_3.a64f0498.png","17Gwb":"pxkw_4.97f2c1d0.png","j0h63":"pxkw_i.ecac8af9.png","a1Zd2":"pxkw_l.943d3009.png","9ibTU":"pxkw_5.82e589ee.png","5iHbQ":"mouse-move.3baa1a3b.png","j0J96":"arrow.2cfbd1f6.png","3E2e3":"mouse-leftclick.0d6b638a.png","3WiuC":"extraction.a7939502.gif","5jDSs":"locked.3f762854.png","8LIGh":"icon_arcane.261d5140.png","ode0x":"icon_bleed.719b5fcf.png","fBSa5":"icon_chaos.77c42696.png","gYNrw":"icon_fire.13a6fa28.png","2Xa6R":"icon_frost.d6a60eb2.png","hXmKT":"icon_holy.b25eb0ae.png","iOqRE":"icon_lightning.9f0965ae.png","3CFcB":"icon_nature.83237930.png","fsFv8":"icon_physical.eb5cbb72.png","lIjHY":"icon_shadow.befc7497.png","l5j8S":"icon_toxic.03c22c48.png","rgAZX":"divider.69456b6e.png","02oa6":"skull.d91ff871.png","aAVOp":"hand_point.81c5bcd1.png","coZR4":"accountIcon-diamond.db39e65e.png","58qUf":"inventory-icon.d47bd16b.png","1Q189":"ping-good.36eeb9b8.png","awhjN":"lootchest.d9e1dcb9.png","dFhUa":"ogre.03eaeaa1.png","eJmGu":"ironfox.549ae886.png","i4qHM":"ghost.5eb7a3c1.png","3lvFJ":"skeleton.842fd341.png","3T6gD":"giantrat.74dc8ba9.png","9i1iT":"darkwizard.c15e0d49.png","561Kr":"treant.f5607d46.png","l1wAQ":"firstbundle.9f7eaeb0.png","23XXF":"supporterbundle.b3f72dc1.png","lIWv2":"foundbundle.34d53247.png","ai1bk":"gems1.ca9ea07f.png","e0uKV":"gems2.c4d068a3.png","fdi53":"gems3.a98c82e8.png","bwLyn":"gems4.833c3102.png","8SAJE":"coin.eebf9b4e.png","d6YVL":"index.2e67a79e.css"}'));


//# sourceMappingURL=index.c42307e9.js.map
